export default __webpack_public_path__ + "static/media/clear1.fe1236db.mp3";